import React from 'react';

const Vue_Component_Instance_emit = () => {
  return (
    <div>
      <h1>Vue_Component_Instance_emit Component</h1>
      <p>This is the Vue_Component_Instance_emit tutorial page.</p>
    </div>
  );
}

export default Vue_Component_Instance_emit;
